import React from 'react';

export default class ServiceError extends React.Component {
    render() {
        return (
            <div>
                <span className="alert-form">{this.props.errorMessage}
                    {this.props.errorLink
                        ? <a href={this.props.errorLink}>{this.props.linkText}</a>
                        : null}
                    </span>
            </div>
        )
    }
};
